import React from "react";
import { Link } from "react-router-dom";
import { BsFillArrowRightCircleFill } from "react-icons/bs";

const SingleProject = ({ img, name, des, link }) => {
  console.log(link);

  return (
    <div class="card lg:w-96 h-full p_box mx-auto w-full max-h-[500px] ml-6 mb-10 bg-base-100 shadow-xl">
      <figure>
        <Link to={`/ProjectDetails/${link}`}>
          <img src={img} alt="Projects" className="p_img relative" />
        </Link>
      </figure>
      <div class=" flex justify-between px-2 items-center text-base-100 text-2xl font-bold py-3 p_details">
        <div>
          <h2 class="">{name}</h2>
          <p class="text-sm font-thin text-accent">{des}</p>
        </div>
        <Link
          to={`/ProjectDetails/${link}`}
          className="text-secondary text-4xl "
        >
          <BsFillArrowRightCircleFill />
        </Link>
      </div>
    </div>
  );
};

export default SingleProject;
